import PropTypes from 'prop-types';

// project imports
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';
import { useAppSelector } from 'hooks';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const NavGroup = ({ item }) => {
    const roles = useAppSelector((state) => state.user.info?.roles) || [];

    const items = item.children
        ?.filter((menu) => {
            if (!menu.authority) return true;
            return roles.includes(menu.authority);
        })
        .map((menu) => {
            switch (menu.type) {
                case 'collapse':
                    return <NavCollapse key={menu.id} menu={menu} level={1} />;
                case 'item':
                    return <NavItem key={menu.id} item={menu} level={1} />;
                default:
                    return null;
            }
        });

    return (
        <div className="gd-nav-group">
            {item.title && <div className="gd-nav-group__title">{item.title}</div>}
            {items}
            <hr className="gd-nav-group__divider" />
        </div>
    );
};

NavGroup.propTypes = {
    item: PropTypes.object
};

export default NavGroup;
